import { useEffect, useState } from "react"
import prodotti_fetch from "../fetch/prodotti_fetch"
import classProdSezzione from "../fetch/classProdSezzione"
import InfoModal from "../riutilizabili/InfoModal"
import { useNavigate } from "react-router"
import TabellaPaginazione from "../riutilizabili/TabellaPaginazione"
import prodSituazione_fetch from "../fetch/prodSituazione_fetch"
import ReadCampiBolla from "../bolla/sezioni/ReadCampiBolla"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEye, faFileLines } from "@fortawesome/free-solid-svg-icons"
import Attendere from "../riutilizabili/Attendere"
import TendinaArrow from "../riutilizabili/TendinaArrow"
import TabProdSezioniOld from "../ProdSituazione/TabProdSezioniOld"
const { format } = require('date-fns');



export default function ViewProdPopUp({
    prodAnId ,
    icona ,
    classiButton='',
    noPopUp=false ,
    soloMagazzino=false
}) {
    const [datiProd , setDatiProd] = useState(false)
    const [prods , setProds] = useState(false)
    const navigate = useNavigate();

    const [pageTot , setPageTot] = useState(0);
    const [pageSize , setPageSize] = useState(20);
    const [page , setPage] = useState(1);
    const [azzeraVar , setAzzeraVar] = useState(0)
    const [fu , setFu] = useState(0)
    const [inputsFiltra , setInputsFiltra] = useState({})
    const [viewBolla , setViewBolla] = useState(false);
    const [viewBollaUscita , setViewBollaUscita] = useState(false);
    const [attivaAttendere , setAttivaAttendere] = useState(false);
    const [inventari, setInventari]= useState([])
    const [inventaroSel, setInventaroSel]= useState(null)

    const [tendinaStato, setTendinaStato]  = useState(false)
    const [tendinaMovOldStato, setTendinaMovOldStato]  = useState(false)

    const [qta , setQta] = useState(0)

    useEffect(()=>{
        if (noPopUp) {
            visualizzaProd()
        }
    },[noPopUp])

    
    const visualizzaProd = async () => {
        const datiProd = await prodotti_fetch.get({id : prodAnId})
       //console.log(datiProd , ' datiProd',prodAnId);

       const response = await prodSituazione_fetch.readProdSituazioneMagazzino({ qtDisp : 1 , prodottoId : prodAnId , sezioneId : 1})
        console.log(response.data[0] , ' responseresponse');
        setQta(response.data[0])
        const array = datiProd.data[0];
        let newArray = {}
        newArray['Codice interno'] = array['rifInterno']
        newArray['Descrizione breve'] = array['descrizioneBreve']
        newArray['Codice a barre'] = array['codBarre']
        newArray["Prezzo d'acquisto (€)"] = array['costo']
        newArray["Prezzo vendità (€)"] = array['prezzoVendita']

        setDatiProd(newArray)
        const prods = await classProdSezzione.get({prodottoId: prodAnId , pageSize , page , orderId :'ASC'})
        //setProds(prods.data.data)
        setPageTot(prods.data.pageTot)

        const inv = await prodSituazione_fetch.ultimiInvProd({prodottoId: prodAnId , soloMagazzino })
        console.log(inv , ' inventari');
        setInventari(inv.data)
        if (inv.data.length > 0) {
            setInventaroSel(inv.data[0].id)
            
            const movimenti = await prodSituazione_fetch.readStoricoProd({prodottoId: prodAnId , soloMagazzino ,inventarioId :inv.data[0].id , page , pageSize})
           //console.log(movimenti.data , ' movimenti');
            setProds(movimenti.data.data)
            setPageTot(movimenti.data.pageTot)
        }else {
            const movimenti = await prodSituazione_fetch.readStoricoProd({prodottoId: prodAnId , soloMagazzino , page , pageSize})
           //console.log(movimenti.data , ' movimenti');
            setProds(movimenti.data.data)
            setPageTot(movimenti.data.pageTot)
        }
        
    }

   //console.log(datiProd , prods , ' datiProd , prods');

    const filtra = async (param) => {
        await classProdSezzione.get({prodottoId: prodAnId , pageSize , page , orderId :'ASC' , ...param})
        .then(response => {
            //console.log(response.data , ' response.data');
            setProds(response.data.data)
            setPageTot(response.data.pageTot)
            setFu(fu+1)
        })
        .catch(error => {
            if (error?.response?.status === 406) {
                navigate("/login");
            }
        })
    }
    
    const impaginazione = async (impaginazione)=> {
        setPage(impaginazione.numeroPag)
        setPageSize(impaginazione.pageSize)
        if ( page !==impaginazione.numeroPag ||  pageSize !== impaginazione.pageSize) {
            await filtra({pageSize:impaginazione.pageSize , page : impaginazione.numeroPag , ...inputsFiltra })
            setAzzeraVar(0)
        }
    }

    const formato = "dd/MM/yyyy HH:mm"; 
    const sottrazione = ['PREL' , 'DDTout']
    const somma = ['DEPO' , 'DDTin']
    const columns = [
         {
            label: 'Data registrazione',
            nome: 'dataOra',
            altCol: (item)=> !!item?.dataOra ? format(item.dataOra ,formato) : ''
        },
        {
            label: 'Descrizione',
            nome: 'descrizione',
            altCol: (item)=> item?.prodotto?.descrizioneBreve
        },
        {
            label: 'Quantità',
            nome: 'quantita',
            altCol: (item)=> (sottrazione.includes(item?.codCausale)  ? '-':( somma.includes(item?.codCausale) ? '+' : ''))+ (item?.codCausale === 'INV' ? item.qtaRimanente :  item?.qta)
        },
        {
            label: 'Fornitore/CLiente',
            nome: 'Posizione',
            altCol: (item)=> {
               //console.log(item , ' item');
                
                return !item?.bollaUscita ? (!item?.bollaEntrata ? '' : item.bollaEntrata.mittente.viewName) : (!!item?.bollaUscita ? item?.bollaUscita.mittente.viewName : '')
            }
        },
        {
            label: 'Magazzino',
            nome: 'Posizione',
            altCol: (item)=> {
                return item?.magazzino ?  item.magazzino.nome  : ''
            }
        },
        {
            label: 'Tipo',
            nome : 'tipo',
            altCol: (item)=> {
                return item?.bollaUscita ?  'DDT in uscita'  : (item?.bollaEntrata ? 'DDT in entrata ' : item.nmeCausale)
            }
        },
        {
            label: 'Documento',
            nome: 'BollaEntrata',
            altCol: (item)=> {
                console.log(!!item?.bollaUscita ,item?.bollaEntrata?.dataOraPartenza , ' item?.bollaEntrata?.dataOraPartenza', item?.bollaEntrata);
                
                return (
                    item?.bollaUscita ? 
                    <span className="d-flex justify-content-center">
                        {!!item?.bollaUscita ? 
                        <span>
                            {item?.bollaUscita?.idProg  + '/' + item?.bollaUscita?.annoId+' - '+( !!item?.bollaUscita && format(item?.bollaUscita?.dataOraPartenza, formato))}
                        </span>
                            : ''
                        }
                         <button onClick={()=>setViewBollaUscita(item.bollaUscita)} className="btn py-0 my-0 pb-1">
                                <FontAwesomeIcon icon={faEye} />
                            </button>
                    </span>

                    : (item?.bollaEntrata ?
                        <span className="d-flex justify-content-center">
                            <span>
                                {item?.bollaEntrata?.numero+' - '+ (!!item?.bollaEntrata?.dataOraPartenza && format(item?.bollaEntrata?.dataOraPartenza, formato))}
                            </span>
                            <button onClick={()=>setViewBolla(item.bollaEntrata)} className="btn py-0 my-0 pb-1">
                                <FontAwesomeIcon icon={faEye} />
                            </button>
                        </span>
                        : ''
                    )
                    
                )
            }
        },
        // {
        //     label: 'BollaUscita',
        //     nome: 'BollaUscita',
        //     altCol: (item)=> {
        //         return !!item?.bollaUscita ? (item?.bollaUscita?.id + '/' + item?.bollaUscita?.annoId+' - '+( !!item?.bollaUscita && format(item?.bollaUscita?.dataCreate, formato))) : ''
        //     }
        // },
    ]
    
    const convertiData = (data) => {
            //console.log(format(new Date(data) ,'dd-MM-yyyy hh:mm') , ' Date ' , data);
            //console.log(data ,' Date 2' , (data+'').indexOf('Z'));
            if ((data+'').indexOf('Z') !== -1) {
                return format(new Date(data) ,'dd-MM-yyyy hh:mm') 
            }
            return format(new Date(data) ,'dd-MM-yyyy') 
    }

   //console.log(datiProd , ' datiProd');
    const CornicePopUp = ({children})=> {
        return(
        <InfoModal
                title={'Articolo '+datiProd['Descrizione breve']}
                canClose
                handleClose={()=>setProds(false)}
                classi=' modal-xxl '
            >
            
            {children}
            <TendinaArrow
                    title='Movimenti fino al 22/07/2025'
                    classi=" me-4"
                    stato={tendinaMovOldStato}
                    setStato={setTendinaMovOldStato}
                    contenuto={
                        <TabProdSezioniOld prodottoId={prodAnId} />
                    }
            />
            </InfoModal>

        )
    }

    const CorniceNoPopUp = ({children})=> {
        return(
            <div>{children}</div>
        )
    }

    const cambiaInventario = async (inventarioId) => {
        setAttivaAttendere(true)
        const movimenti = await prodSituazione_fetch.readStoricoProd({
            prodottoId: prodAnId , 
            soloMagazzino ,
            inventarioId :inventarioId , 
            page : 1 , 
            pageSize
        })

        setPage(1)
        setProds(movimenti.data.data)
        setPageTot(movimenti.data.pageTot)
        setInventaroSel(inventarioId)
        setAttivaAttendere(false)
    }

    const Cornice = noPopUp ? CorniceNoPopUp : CornicePopUp
        console.log(datiProd , ' datiProd');
            
    return(
        <>
            {!noPopUp &&<button className={"btn "+classiButton} onClick={visualizzaProd}>
                {icona}
            </button>}

            {!!prods &&
            <Cornice>

                <div>
                    <div className=" mb-5 d-flex justify-content-between ms-0 flex-wrap border border-primary rounded m-2 me-4">
                        {Object.keys(datiProd).map((item , key) => {
                                   //console.log(item, ' itemc ', datiProd[item]);
                                    return(
                                        <div key={key} className="p-2 d-flex flex-column  m-4" >
                                            <span className='fw-bold' > {item} </span>
                                            {datiProd[item] !== null ? datiProd[item] : ' '}
                                        </div>
                                    )
                                })}
                    </div>

                    <div className="col-12 text-center">
                        <p className="col-12 fw-bold" >Articoli presenti in {qta.magazzino} : {qta.qta} </p>
                    </div>

                    {inventari.length > 0 ?
                            <div className='ps-0 ms-0 p-3 pt-5 pe-4'>
                                <div className="pb-0  mb-0 border-0 ms-5">
                                    {inventari.map(item => 
                                    <button onClick={()=>cambiaInventario(item.id)}  className={(inventaroSel === item.id && 'bg-primary' )+" pb-0 mb-0 border-bottom-0 rounded-top-1 border-primary border-1 bg_secondary fw-bold "}>
                                        {format(new Date(item.dataInventario), 'dd/MM/yyyy HH:mm')}
                                    </button>
                                    
                                    )}
                                </div>
                                <TabellaPaginazione
                                    colonne={columns}
                                    dati={prods}
                                    totalePag={pageTot}
                                    azzera={azzeraVar}
                                    impaginazione={impaginazione}
                                    fu={fu}
                                    filtroTopTable
                                    classi=' ms-0 ps-0 '
                                />
                            </div>
                    
                    :
                    <>
                        <div className='ps-0 ms-0 p-3 pt-5 pe-4'>
                            Nessun inventario presente
                        </div>
                        {prods.length > 0 && <TabellaPaginazione
                            colonne={columns}
                            dati={prods}
                            totalePag={pageTot}
                            azzera={azzeraVar}
                            impaginazione={impaginazione}
                            fu={fu}
                            filtroTopTable
                            classi=' ms-0 ps-0 '
                        />}
                    </>
                    }
                    
                </div>

           </Cornice>}

            {!!viewBolla && 
                <InfoModal
                    size='xl'
                    title={'Ddt n° ' +viewBolla.numero}
                    text={
                        <ReadCampiBolla inputs={viewBolla} infoAddView={false}/>
                    }
                    canClose
                    handleClose={()=>setViewBolla(false)}
                    className = 'modal-lg'
                />
            }

            {!!viewBollaUscita && 
                <InfoModal
                    title={ 
                    <h3 className="text-white d-flex align-items-center ps-3" >
                        <FontAwesomeIcon className="me-3 text-white" icon={faFileLines} />
                        DDT N° { viewBollaUscita?.idProg+'/'+viewBollaUscita?.annoId+(!!viewBollaUscita?.codiceMag ? ' - '+viewBollaUscita.codiceMag : '') + ' del ' +convertiData(viewBollaUscita?.dataFattura) }
                    </h3>
                    }
                    text={
                        <ReadCampiBolla inputs={viewBollaUscita} cliente={true} />
                    }
                    canClose
                    handleClose={()=>setViewBollaUscita(false)}
                    className = 'modal-xl'
                />
            }
            {!!attivaAttendere && <Attendere />}
        </>
    )
}